//@flow
import {LOCATION_ACTIONS} from './type';
import type {Location, Action} from './type';

export const initialLocations: Location[] = [];

export function reducer(state: Location[], action: Action): Location[] {
  switch (action.type) {
    case LOCATION_ACTIONS.TOGGLE_EXPAND:
      return toggleExpand(state, action.indexes);
    case LOCATION_ACTIONS.TOGGLE_CHECK:
      return toggleCheck(state, action.indexes);
    case LOCATION_ACTIONS.SET_SUB_LOCATIONS:
      return setSubLocations(state, action.indexes, action.subLocations);
    case LOCATION_ACTIONS.CLEAR_ALL:
      return clearAll(state);
    case LOCATION_ACTIONS.SET_INITIAL_LOCATIONS:
      return action.subLocations;

    default:
      return state;
  }
}

function toggleExpand(state: Location[], indexes: number[]): Location[] {
  const newState = [...state];
  let currentLevel = newState;

  indexes.forEach((index, i) => {
    if (i === indexes.length - 1) {
      currentLevel.forEach((item, itemIndex) => {
        if (itemIndex !== index) {
          item.isExpanded = false;
        }
      });
      currentLevel[index].isExpanded = !currentLevel[index].isExpanded;
    } else {
      currentLevel = currentLevel[index].subLocations;
    }
  });

  return newState;
}

function toggleCheck(state: Location[], indexes: number[]): Location[] {
  const newState = [...state];
  let currentLevel = newState;

  const updateSubLocations = (
    subLocations: Location[],
    isChecked: boolean
  ): Location[] => {
    return subLocations.map(subLocation => {
      if (subLocation.isDisabled) {
        return subLocation;
      }

      return {
        ...subLocation,
        isChecked: isChecked,
        indeterminate: false,
        subLocations: updateSubLocations(subLocation.subLocations, isChecked),
      };
    });
  };

  const updateParentState = (parent: Location) => {
    if (!parent.subLocations) return;
    const allChecked = parent.subLocations.every(sub => sub.isChecked);
    const noneChecked = parent.subLocations.every(
      sub => !sub.isChecked && !sub.indeterminate
    );
    if (allChecked) {
      parent.isChecked = true;
      parent.indeterminate = false;
    } else if (noneChecked) {
      parent.isChecked = false;
      parent.indeterminate = false;
    } else {
      parent.isChecked = false;
      parent.indeterminate = true;
    }
  };

  indexes.forEach((index, i) => {
    if (i === indexes.length - 1 && !currentLevel[index].isDisabled) {
      const isChecked = !currentLevel[index].isChecked;
      currentLevel[index].isChecked = isChecked;
      currentLevel[index].indeterminate = false;
      currentLevel[index].subLocations = updateSubLocations(
        currentLevel[index].subLocations,
        isChecked
      );
    } else {
      currentLevel = currentLevel[index].subLocations;
    }
  });

  for (let i = indexes.length - 2; i >= 0; i--) {
    let parentIndexes = indexes.slice(0, i + 1);
    let parent = newState;
    parentIndexes.forEach((index, j) => {
      if (j === parentIndexes.length - 1) {
        updateParentState(parent[index]);
      } else {
        parent = parent[index].subLocations;
      }
    });
  }

  return newState;
}

function setSubLocations(
  state: Location[],
  indexes: number[],
  subLocations: Location[]
): Location[] {
  const newState = [...state];
  let currentLevel = newState;
  indexes.forEach((index, i) => {
    if (i === indexes.length - 1) {
      currentLevel[index].subLocations = subLocations;
    } else {
      currentLevel = currentLevel[index].subLocations;
    }
  });
  return newState;
}

function clearAll(state: Location[]): Location[] {
  const clearLocations = (locations: Location[]): Location[] => {
    return locations.map(location => ({
      ...location,
      isChecked: false,
      indeterminate: false,
      subLocations: location.subLocations
        ? clearLocations(location.subLocations)
        : [],
    }));
  };
  return clearLocations(state);
}
